"use client";

import {
  createContext,
  useState,
  type Dispatch,
  type SetStateAction,
} from "react";

export const AuthModalContext = createContext<
  [isModalOpen: boolean, setIsModalOpen: Dispatch<SetStateAction<boolean>>]
>([
  false,
  () => {
    // do nothing
  },
]);

export default function AuthModalProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <AuthModalContext.Provider value={[isModalOpen, setIsModalOpen]}>
      {children}
    </AuthModalContext.Provider>
  );
}
